import { POST } from '../config'

import { IAuthCredentials, IAuthResponse } from '../../../interfaces/auth.interface'
import { IOtpPayload, IOtpResponse } from '../../../interfaces/otp.interface'

export interface IAuthAPI {
  login: (payload: IAuthCredentials) => Promise<IAuthResponse>
  otp: (payload: IOtpPayload) => Promise<IOtpResponse>
}

export default {
  login: (payload: IAuthCredentials): Promise<IAuthResponse> => {
    return POST('/api/v1/login/', payload).then((res) => res.data)
  },

  otp: (payload: IOtpPayload): Promise<IOtpResponse> => {
    return POST('/api/v1/login/validate/', payload).then((res) => res.data)
  },
}
